// Configurazione API Country Manager
//
// Architettura produzione:
//   - Solo il FRONTEND è esposto (es. https://country.gsgabry.it)
//   - Il BACKEND resta in ascolto solo in locale (:3001)
//   - Il browser chiama sempre /api sullo STESSO host del frontend
//   - OpenResty/Nginx inoltra /api → http://127.0.0.1:3001 (mai esporre :3001 al pubblico)
//
// Sviluppo locale: frontend :3000, backend :3001 (chiamata diretta).

const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || '3001';

const getConfig = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const frontendPort = window.location.port;

  const isLocalDev =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]';

  if (isLocalDev) {
    return {
      API_BASE_URL: `http://localhost:${BACKEND_PORT}`,
      ENV: 'development',
    };
  }

  // Porte standard = frontend pubblico dietro reverse proxy (80/443)
  const isPublicFrontend =
    !frontendPort || frontendPort === '80' || frontendPort === '443';

  if (isPublicFrontend) {
    // API sullo stesso origin: https://country.gsgabry.it/api/...
    return {
      API_BASE_URL: `${protocol}//${hostname}`,
      ENV: 'production',
    };
  }

  // Fallback LAN: accesso diretto al frontend su :3000 senza proxy /api
  return {
    API_BASE_URL: `${protocol}//${hostname}:${BACKEND_PORT}`,
    ENV: 'production',
  };
};

export const config = getConfig();
export const API_BASE_URL = config.API_BASE_URL;
export const ENV = config.ENV;
export const APP_VERSION = '2.0.0';

console.log('Country Manager Config:', {
  hostname: window.location.hostname,
  API_BASE_URL,
  ENV,
});
